import { render } from "./personalized.vue?vue&type=template&id=465ab7f6&scoped=true"
import script from "./personalized.vue?vue&type=script&lang=js"
export * from "./personalized.vue?vue&type=script&lang=js"

import "./personalized.vue?vue&type=style&index=0&id=465ab7f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465ab7f6"]])

export default __exports__